import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getFeedbackSurveyId, getDisplayEditorFeedbackSurvey } from 'FormsUI/selectors/FeedbackSurveys';
import { useFormRoutingContext } from 'FormsUI/components/editor/options/routing/FormRoutingProvider';
import { getFeedbackSurveyForEnviro } from 'FormsUI/utils/FeedbackSurveys';
import { CAST_FORM_ROUTING } from 'ui-forms-components/constants/FeedbackSurveys';
const useFeedbackSurvey = step => {
  const {
    routing
  } = useFormRoutingContext();
  const {
    formRoutingEnabled,
    formRoutingLoading
  } = routing;
  const feedbackSurveyIdFromSelector = useSelector(getFeedbackSurveyId);
  const dispalyEditorFeedbackSurvey = useSelector(() => getDisplayEditorFeedbackSurvey(step));
  const routingFeedbackSurvey = getFeedbackSurveyForEnviro(CAST_FORM_ROUTING);
  const feedbackSurveyId = useMemo(() => {
    if (formRoutingEnabled) {
      return routingFeedbackSurvey;
    }
    return feedbackSurveyIdFromSelector;
  }, [formRoutingEnabled, routingFeedbackSurvey, feedbackSurveyIdFromSelector]);
  const shouldDisplaySurvey = dispalyEditorFeedbackSurvey && !formRoutingLoading;
  return {
    shouldDisplaySurvey,
    feedbackSurveyId
  };
};
export default useFeedbackSurvey;